function validateTaskCopy (taskCopy, isValid) {
  let errorMessage = ''

  if (!taskCopy.postoje && (!taskCopy.zaladunek || !taskCopy.rozladunek)) {
    isValid = false
    errorMessage = 'Godziny załadunku i rozładunku zlecenia są wymagane. Proszę wprowadzić załadunek i rozładunek zlecenia'
  }

  return { isValid: isValid, errorMessage: errorMessage }
}

export { validateTaskCopy }
